module.exports = require("./zgh.d.ts");